import {isNullOrUndefined} from "../../../services/Validator";

export default function LevelACardHeaderText({text}) {
    // Used through LevelAScreen to display card header text

    // BUILD
    if (isNullOrUndefined(text))
        return null
    return (
        <span className={"text-[16px] font-medium text-greyLight7"}>
            {text}
        </span>
    );
}